export default {"src":"/_next/static/media/fluent-error-circle.ce0e8948.svg","height":34,"width":34};